import { hot } from '../util/react-hot-ts';
import { launchPanelApp } from './lib/PanelApp';

// Page specific code :
import DomainHostingAdd from './pages/domain-hosting-add/DomainHostingAdd';

hot(module)(launchPanelApp(DomainHostingAdd, {}));
